import React from 'react';
import logo from '../assets/logo.svg'; // Adjust the path as necessary

const Logo = () => {
	return (
		<img src={logo} alt="FilmFinder Logo" width="40" height="40" />
	);
};

export default Logo;
